import moment from "moment";

export function defaultCampanhaMetasItem() {
  return {
    id: null,
    nome: "",
    tipoCampanha: "D",
    tipoApuracao: "P",
    metaTotal: 0,
    total: 0,
    image: null,
    dataInicio: moment().format(),
    dataFim: moment().add(1, "days").format(),
    dataApuracao: null,
    status: "Não apurada",
    fechado: false,
    metasOperadores: [],
    metasRepresentantes: [],
    mix: [],
    dimensoes: [],
  };
}

// A campanha de metas precisa de ao menos um publico: operadores (CallCenter)
// ou representantes (Forca de Vendas).
export function possuiPublicoMeta(item) {
  const operadores = (item && item.metasOperadores) || [];
  const representantes = (item && item.metasRepresentantes) || [];

  return operadores.length > 0 || representantes.length > 0;
}

export function somaMetas(metas) {
  return (metas || []).reduce((total, meta) => total + (+meta.vlMeta || 0), 0);
}

// A API pode devolver a campanha sem uma das listas de publico; o formulario,
// o PUT e a duplicacao trabalham sempre com as duas listas.
export function normalizaPublicoMeta(campanha) {
  return {
    ...campanha,
    metasOperadores: (campanha && campanha.metasOperadores) || [],
    metasRepresentantes: (campanha && campanha.metasRepresentantes) || [],
  };
}

// Positivacao, % de mix e valor sao obrigatorios na API: campo apagado na
// mascara chega como "" e derrubaria o save inteiro.
export function metaPreenchida(meta) {
  return ["positivacao", "percMix", "vlMeta"].every((campo) => {
    const valor = meta && meta[campo];
    return valor !== undefined && valor !== null && String(valor).trim() !== "";
  });
}

export function filtrarValidos(itemArray, referencia, compareFn) {
  const validos = itemArray.filter((item) =>
    referencia.some((ref) => compareFn(item, ref))
  );

  if (validos.length !== itemArray.length) {
    return validos;
  }

  return itemArray;
}

// Ids/codigos vindos do ERP podem ser alfanumericos (ex.: "913-2582"), entao a
// comparacao precisa ser textual -- com coercao numerica o `+valor` viraria NaN
// e nunca casaria.
export function mesmaChaveTextual(a, b) {
  if (a === null || a === undefined || b === null || b === undefined) {
    return false;
  }

  return String(a).trim() === String(b).trim();
}

// Aliases de dominio: preservam a legibilidade nas chamadas sem duplicar a regra.
export const mesmoProdutoId = mesmaChaveTextual;
export const mesmoCodigoOperador = mesmaChaveTextual;
export const mesmoCodigoRepresentante = mesmaChaveTextual;

// Remove metas de representantes que nao estao mais na lista de elegiveis
// (inativos/removidos), mesma regra da aba de operadores. Com a lista vazia
// (ainda nao carregou ou falhou) nada e removido.
export function representantesValidos(metas, representantes) {
  if (!representantes || representantes.length === 0) {
    return metas || [];
  }

  return filtrarValidos(metas || [], representantes, (meta, representante) =>
    mesmoCodigoRepresentante(meta.codRep, representante.codRep)
  );
}

// Metas que representantesValidos tiraria do payload. No save de uma campanha
// ja apurada isso apaga o realizado do representante na API, entao o
// formulario pede confirmacao antes de remover.
export function representantesForaDosElegiveis(metas, representantes) {
  const validos = representantesValidos(metas, representantes);

  return (metas || []).filter((meta) => !validos.includes(meta));
}

export function resetValidacaoPorTipo(item, validacao) {
  if (item.tipo === "MIX") {
    validacao.reset("item.dimensoes");
  } else {
    validacao.reset("item.mixProdutos");
  }
}

// Re-exporta helpers de campanhas comerciais para acesso centralizado
export {
  computeStatus,
  getStatusConfig,
} from "@/views/Campanhas/components/CampanhasComerciais/helpers/campanhaStatus";
export {
  getValidacaoLabel,
  getTipoLabel,
} from "@/views/Campanhas/components/CampanhasComerciais/helpers/campanhaLabels";
export {
  defaultCampanhaComercial,
  normalizeCampanhaParaApi,
} from "@/views/Campanhas/components/CampanhasComerciais/helpers/campanhaDefaults";